
import { profileTranslations } from './translations/profile';
import { subscription } from './translations/en/subscription';
import { goals } from './translations/en/goals';
import { general } from './translations/en/general';
import { timeManagement } from './translations/en/time-management';
import { habits } from './translations/en/habits';
import { journal } from './translations/en/journal';
import { finance } from './translations/en/finance';
import { reminders } from './translations/en/reminders';
import { feedback } from './translations/en/feedback';
import { dashboard } from './translations/en/dashboard';
import { notes } from './translations/en/notes';
import { featuresEn } from './translations/en/features';
import { auth } from './translations/en/auth';
import { tasks } from './translations/en/tasks';
import { settings } from './translations/en/settings';
import { blog } from './translations/en/blog';
import { orders } from './translations/en/orders';
import { products } from './translations/en/products';
import { admin } from './translations/en/admin';
import { lists } from './translations/en/lists';
import { ideas } from './translations/en/ideas';
import { email } from './translations/en/email';
import { documents } from './translations/en/documents';
import { productivity } from './translations/en/productivity';
import { landing } from './translations/en/landing';
import { financialEducation } from './translations/en/financial-education';
import { productivityEducation } from './translations/en/productivity-education';
import { annualPlan } from './translations/en/annual-plan';

// Core translations shared between language files
// Helper to flatten nested translation modules with dot-prefixed keys
const flattenWithPrefix = (obj: any, prefix: string): Record<string, string> => {
  const result: Record<string, string> = {};
  const walk = (o: any, path: string[]) => {
    Object.entries(o).forEach(([k, v]) => {
      const next = [...path, k];
      if (v && typeof v === 'object' && !Array.isArray(v)) {
        walk(v, next);
      } else {
        result[`${prefix}.${next.join('.')}`] = String(v);
      }
    });
  };
  walk(obj, []);
  return result;
};

// Core translations shared between language files
const translations = {
  ...general,
  ...auth,
  ...profileTranslations,
  ...subscription,
  ...goals,
  ...timeManagement,
  ...habits,
  ...journal,
  ...finance,
  ...reminders,
  ...feedback,
  ...dashboard,
  ...notes,
  ...featuresEn,
  ...tasks,
  ...settings,
  ...blog,
  ...orders,
  ...products,
  ...admin,
  ...lists,
  ...ideas,
  ...email,
  ...documents,
  ...productivity,
  ...landing, // Spread landing for direct access (e.g., t('heroTitle'))
  ...financialEducation,
  ...flattenWithPrefix(productivityEducation, 'productivityEducation'),
  ...annualPlan,
  // Also add nested access for newsletter popup
  landing, // Add nested structure for dot notation (e.g., t('landing.newsletter.comingSoon'))
  // Additional common translations
  tryAgainLater: 'Please try again later.',
  recentTransactions: 'Recent Transactions',
  saveAndNew: 'Save and New',
  saveChanges: 'Save Changes',

  // Voucher dot-key mappings expected by components
  'finance.transactions.voucher.short': finance.voucherShort,
  'finance.transactions.voucher.label': finance.voucherLabel,
  'finance.transactions.voucher.dragOrClick': finance.voucherDragOrClick,
  'finance.transactions.voucher.dropHere': finance.voucherDropHere,
  'finance.transactions.voucher.supportedFormats': finance.voucherSupportedFormats,
  'finance.transactions.voucher.uploaded': finance.voucherUploaded,
  'finance.transactions.voucher.view': finance.voucherView,
  'finance.transactions.voucher.preview': finance.voucherPreview,
  'finance.transactions.voucher.invalidFileType': finance.voucherInvalidFileType,
  'finance.transactions.voucher.allowedTypes': finance.voucherAllowedTypes,
  'finance.transactions.voucher.fileTooLarge': finance.voucherFileTooLarge,
  'finance.transactions.voucher.maxSize': finance.voucherMaxSize,
  'finance.transactions.voucher.uploadError': finance.voucherUploadError,
  'finance.transactions.voucher.uploadSuccess': finance.voucherUploadSuccess,
  'finance.transactions.voucher.deleteSuccess': finance.voucherDeleteSuccess,
};

export default translations;
